import VueCookies from 'vue-cookies';
let token =  VueCookies.get('token') || null;
let regParams = {}; //注册参数
if (process.env.NODE_ENV == 'development') {    
     // token = '' 
	 // regParams= VueCookies.get('regParams') || {};
} 
else if (process.env.NODE_ENV == 'debug') {    
} 
else if (process.env.NODE_ENV == 'production') {    
}
export default {
    userInfo: null,
    token,
    regParams,
}


